import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Activity, Loader2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "medico" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <form onSubmit={submit} className="w-full max-w-sm space-y-6 animate-fade-up" data-testid="register-form">
        <div className="flex items-center gap-2 mb-2">
          <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center">
            <Activity className="w-6 h-6 text-primary-foreground" strokeWidth={2.5} />
          </div>
          <span className="font-heading font-extrabold text-xl">LIA</span>
        </div>
        <div>
          <h1 className="font-heading text-3xl font-bold tracking-tight">Criar conta</h1>
          <p className="text-muted-foreground text-sm mt-1">Comece a usar a LIA Clínica com IA.</p>
        </div>

        <div className="space-y-2">
          <Label htmlFor="name">Nome completo</Label>
          <Input id="name" value={form.name} onChange={set("name")} data-testid="register-name" required />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">E-mail</Label>
          <Input id="email" type="email" value={form.email} onChange={set("email")} data-testid="register-email" required />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Senha</Label>
          <Input id="password" type="password" value={form.password} onChange={set("password")} data-testid="register-password" required />
        </div>

        {error && <p className="text-sm text-destructive" data-testid="register-error">{error}</p>}

        <Button type="submit" className="w-full" disabled={loading} data-testid="register-submit">
          {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Criar conta
        </Button>

        <p className="text-sm text-muted-foreground text-center">
          Já tem conta?{" "}
          <Link to="/login" className="text-primary font-medium hover:underline" data-testid="link-login">Entrar</Link>
        </p>
      </form>
    </div>
  );
}
